export default function AboutCTA() {
  return (
    <section className="bg-[#1A1A1A] py-16 md:py-24 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-4xl mx-auto text-center">
        <h2
          className="text-3xl md:text-5xl font-bold text-white mb-8"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Ready to Build with the Best?
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/products"
            className="bg-[#F2C612] text-black px-8 py-4 rounded-lg font-semibold text-base whitespace-nowrap hover:bg-[#d4ad0a] transition-colors cursor-pointer"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            View Our Products
          </a>
          <a
            href="/contact"
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-base whitespace-nowrap hover:bg-white hover:text-black transition-colors cursor-pointer"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}